module.exports = __webpack_public_path__ + "b0e7b501bafe528b5c5bc371825b6468.png";